import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorRequest } from 'src/app/api/models';
import { ErrorService } from '../error.service';
@Component({
  selector: 'bom-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  @Input()
  statusCode: string;

  @Input()
  date: moment.Moment;

  @Input()
  correlationId: string;

  error$: Observable<ErrorRequest> = of(null);

  private componentDestroyed$ = new Subject<any>();

  constructor(private route: ActivatedRoute, private errorService: ErrorService) { }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe(p => {
      if (p.correlationid) {
        this.correlationId = p.correlationid;
      }

      if (p.httpStatusCode) {
        this.statusCode = p.httpStatusCode;
      } else if (p.statusCode) {
        this.statusCode = p.statusCode;
      }

      if (p.date) {
        this.date = moment(p.date);
      }

      if (p.errorId) {
        this.error$ = this.errorService.getFromStorage(p.errorId);
      }
    });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
